import { render, staticRenderFns } from "./OtherRecommendation.vue?vue&type=template&id=3ab610c0&scoped=true&"
import script from "./OtherRecommendation.vue?vue&type=script&lang=js&"
export * from "./OtherRecommendation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab610c0",
  null
  
)

export default component.exports